import styled from 'styled-components';
import { Checkbox, Input, Select } from '@studio/legacy-components';

export const HelpText = styled.p`
  color: var(--sharkbait-ooh-la-la);
`;

export const OptionWrapper = styled.div`
  ${Input}, ${Select} {
    margin: 4px 24px 20px 24px;
    min-width: 50%;
  }

  ${Checkbox} label {
    font-weight: var(--regular);
  }
`;
